import { useTheme } from '@repo/theme';
import { getNavigationThemes } from 'component/navigation/theme';
import { Stack } from 'expo-router';
import { ThemeProvider } from 'expo-router/react-navigation';
import { useMemo } from 'react';

export default function AppLayout() {
    const tokens = useTheme();
    const { defaultNavigationTheme } = useMemo(() => getNavigationThemes(tokens), [tokens]);

    return (
        <ThemeProvider value={defaultNavigationTheme}>
            <Stack screenOptions={{ headerShown: false }} />
        </ThemeProvider>
    );
}
